import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HC_more from 'highcharts/highcharts-more';
import classNames from 'classnames/bind';
import styles from './PieChartElement.module.scss';
import { useTheme } from '@mui/material';

const cx = classNames.bind(styles);


HC_more(Highcharts);

export type PieChartData = { name: string, value: number }[]

const COLOR_CHART = [
    "#B54141",
    "#DBA95D",
    "#49CF5F",
    "#0BB48B",
    "#1289AF",
    "#25429F",
    "#671DD0",
]

function getRandomHexColor() {
    const r = Math.floor(Math.random() * 256).toString(16).padStart(2, '0');
    const g = Math.floor(Math.random() * 256).toString(16).padStart(2, '0');
    const b = Math.floor(Math.random() * 256).toString(16).padStart(2, '0');
    return `#${r}${g}${b}`;
}

function getRandomColor(len: number) {
    let newColor = []
    if (len <= COLOR_CHART.length) {
        return COLOR_CHART
    } else {
        newColor = [...COLOR_CHART]
        for (let index = 0; 0 < len - newColor.length; index++) {
            const newC = getRandomHexColor()
            if (!newColor.includes(newC)) {
                newColor.push(newC)
            }
        }
    }
    // const r = Math.floor(Math.random() * 256).toString(16).padStart(2, '0');
    // const g = Math.floor(Math.random() * 256).toString(16).padStart(2, '0');
    // const b = Math.floor(Math.random() * 256).toString(16).padStart(2, '0');
    // return `#${r}${g}${b}`;
    return newColor
}

interface Props {
    isLongLabel?: boolean,
    dataSeries: { name: string, value: number }[]
}

const PieChartElement = (props: Props) => {
    const theme = useTheme()
    const { dataSeries, isLongLabel } = props

    const series: any[] = dataSeries


    const options: Highcharts.Options = {
        chart: {
            type: 'pie',
            backgroundColor: 'transparent',
        },
        title: {
            text: undefined
        },
        tooltip: {
            pointFormat: '{series.name}: <b>{point.percentage:.2f}%</b>'
        },
        accessibility: {
            point: {
                valueSuffix: '%'
            }
        },
        plotOptions: {
            pie: {
                size: '70%',
                innerSize: '60%',
                borderWidth: 0,
                dataLabels: {
                    enabled: true,
                    format: '{point.name}: <b>{point.percentage:.2f}%</b>',
                    style: {
                        color: theme.palette.text.primary
                    },
                },
                showInLegend: true,
            },
        },
        legend: {
            align: 'right',
            verticalAlign: 'middle',
            layout: 'vertical',
            useHTML: true,
            labelFormat: `<p style="color: ${theme.palette.text.primary}; font-size: 14px;">{name}:&nbsp;&nbsp;&nbsp;<span style="color: ${theme.palette.text.secondary}; font-size: 14px;">({percentage:.2f}%)</span></p>`

        },
        colors: getRandomColor(dataSeries?.length ?? 0),
        series: [{
            type: "pie",
            // colorByPoint: true,
            data: series.map((s) => ({ name: s.name, y: s.value })),
        }],
        exporting: {
            enabled: false,
        },
        responsive: {
            rules: [{
                condition: {
                    maxWidth: isLongLabel === true ? 760 : 500
                },
                chartOptions: {
                    plotOptions: {
                        pie: {
                            dataLabels: {
                                enabled: false // Disable data labels for small screens
                            }
                        }
                    }
                }
            }]
        }
    };

    return (
        <HighchartsReact
            containerProps={{ class: cx('pie-chart-custom') }}
            highcharts={Highcharts}
            options={options}
        />
    );
};

export default PieChartElement;